<template>
    <!-- Started from example(s) on this page: https://www.npmjs.com/package/vue3-dropzone -->
    <div v-bind="getRootProps()">
        <input v-bind="getInputProps()" />
        <slot></slot>

        <div
            class="btn btn-light spinner spinner-left my-4"
            v-if="is_uploading"
        >
            {{ translate("Uploading") }}...
        </div>
    </div>
</template>

<script>
import { useDropzone } from "vue3-dropzone";
import axios from "axios";
import { ref } from "vue";

export default {
    props: ["upload_url", "accepted_file_types", "max_file_size"], // accepted_file_types can be application/pdf / image/png / image/jpeg. NOTE: For Doc we have issues: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    // max_file_size is optional, in bytes. When omitted, no client-side size limit is enforced.

    setup(props, { emit }) {
        const is_uploading = ref(false);

        // var self = this;
        // const url = "{your_url}"; // Your url on the server side
        // const url = "/api/author/presentations/1/documents/sample";
        const url = props.upload_url;
        const saveFiles = (files) => {
            const formData = new FormData(); // pass data as a form
            for (var x = 0; x < files.length; x++) {
                // append files as array to the form, feel free to change the array name
                formData.append("file[]", files[x]); // IMPORTANT: Must have [] to allow multiple file upload!
            }

            is_uploading.value = true;

            axios
                .post(url, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    emit("uploadSuccessful", response.data);
                    is_uploading.value = false;
                })
                .catch((err) => {
                    console.error(err);
                    is_uploading.value = false;

                    const errors = err.response?.data?.errors;
                    const message = errors
                        ? Object.values(errors).flat().join(" ")
                        : err.response?.data?.message ||
                          "Something went wrong while uploading the file.";

                    emit("uploadFailed", message);
                });
        };

        function onDrop(acceptFiles, rejectReasons) {
            if (
                rejectReasons.some((rejection) =>
                    rejection.errors.some(
                        (error) => error && error.code === "file-too-large",
                    ),
                )
            ) {
                return emit("uploadFailedDueToFileSize");
            }

            for (var x = 0; x < acceptFiles.length; x++) {
                if (!props.accepted_file_types.includes(acceptFiles[x].type))
                    return emit("uploadFailedDueToFileTypes");
            }

            saveFiles(acceptFiles); // saveFiles as callback
        }

        const { getRootProps, getInputProps, ...rest } = useDropzone({
            onDrop,
            accept: props.accepted_file_types
                ? props.accepted_file_types.join(",")
                : "",
            maxSize: props.max_file_size || undefined,
        });

        return {
            is_uploading,
            getRootProps,
            getInputProps,
            ...rest,
        };
    },
};
</script>
